import { Middleware } from "redux";
import { applyMiddleware, legacy_createStore as createStore, compose } from "redux";
//import reduxThunk from 'redux-thunk';
import { thunk as reduxThunk } from 'redux-thunk';
import createReducer, { ReducerMap } from 'app/startup/createReducer';
import { Store } from "redux";
import {getStartupAction} from 'app/startup/pageData';

declare const DEBUG: string;
declare global {
    interface Window { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any|undefined; }
}

function isDebug() {
    try {
        let d = JSON.parse(DEBUG);
        return !!d;
    }
    catch (err) {
        return false;
    }
}

function createMiddlewareEnhancer() {
    const middleware : Middleware[] = [reduxThunk];
    if (!isDebug()) {
        //middleware.push(crashReportMiddleware);
    }
    let composeEnhancers = compose; 
    if (isDebug() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    const enhancer = composeEnhancers(applyMiddleware(...middleware));
    return enhancer;
}

export async function initalizeStore(dynamicReducers: ReducerMap) {
    const reducer = createReducer(dynamicReducers);
    const store = createStore(reducer, {}, createMiddlewareEnhancer());

    const startupAction = await getStartupAction();
    store.dispatch(startupAction);
    return store;
}

export type RootState = Record<string, unknown>;

export function changeDynamicReducers(store:Store<{}>, dynamicReducers: ReducerMap) {
    const newReducer = createReducer(dynamicReducers);
    store.replaceReducer(newReducer);
    store.dispatch({type: 'framework/reducersChanged'});
}